import { EButton, EModal, EMultiSelect, EPageTitle, ESelect, ETable } from 'libs/ui';
import PageLayout from 'PageLayout';
import React from 'react'
import { IoMdAdd } from 'react-icons/io';
import { useBlockAirlines } from './hook/useBlockAirlnes';
import ESwitch from 'libs/ui/src/Switch/ESwitch';
import {Tooltip } from "@mantine/core";
import { FaRegEdit } from 'react-icons/fa';
 
function BlockAirlines() {
  const {
    blockedList,
    isOpenModalValue, setIsOpenModalValue,
    isLoading, setIsLoading,
    supplierList,
    selectedSupplier,setSelectedSupplier,
    airlinesList,
    selectedAirlines, setSelectedAirlines,
    isSwitchLoadingIndex, setIsSwitchLoadingIndex,
    submitBlockedAirlines,resetStates,setEditedAirline,updateBlockedAirlines,
    flightTypesList,
    selectedFlightTypes, setSelectedFlightTypes
   } = useBlockAirlines();

  return (
    <PageLayout>
        <EPageTitle
                title="Block Airlines from Supplier"
                end={
                    <div className="flex gap-1">
                        <EButton
                            rightSection={<IoMdAdd />}
                            onClick={() => { 
                                setIsOpenModalValue("New")
                             }}
                        >
                            Add New
                        </EButton>
                    </div>
                }
        />
        {/* Blocked Airlines List */}
            <ETable
                loading={isLoading}
            >
                <thead>
                    <tr>
                        <th>SR. No.</th>
                        <th>Types</th>
                        <th>Suppliers Name</th>
                        <th>Airline Name</th>
                        <th>Code</th>
                        <th>Status</th>
                        <th ></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        blockedList?.map((each, index) => {
                            return (
                                <tr key={`block-${index}`}>
                                    <td>{index + 1}</td>
                                    <td>{each.isDomesticRestricted ? 'Domestic':''}{" "}
                                        {each.isInternationalRestricted ? 'International':''}
                                    </td>
                                    <td>{each.supplierName}</td>
                                    <td>{each.airlineName}</td>
                                    <td>{each.airlineCode}</td>
                                    <td>
                                        <ESwitch 
                                            label={each.isRestricted ? "Blocked" : "Not Blocked"}
                                            loading={isSwitchLoadingIndex === (index + 1)}
                                            checked={!each.isRestricted}
                                            onChange={() => { 
                                                updateBlockedAirlines(each);
                                            }}
                                            withConfirmation
                                        />
                                    </td>
                                    <td
                                        className="flex w-full gap-1 items-center justify-end">
                                        {/* <Tooltip label="Edit" position="top" >
                                            <div>
                                                <FaRegEdit
                                                    size={16}
                                                    className="cursor-pointer text-green-400 hover:text-green-600"
                                                    onClick={() => {
                                                        setIsOpenModalValue("Edit")
                                                        setEditedAirline(each)
                                                    }}
                                                />
                                            </div>
                                        </Tooltip> */}
                                        {/* <Tooltip label="Delete">
                                                        <div>
                                                        <MdDeleteForever
                                                            size={16}
                                                            className="cursor-pointer text-orange-400 hover:text-orange-600"
                                                            onClick={() => {
                                                                setIsOpenModalValue("Delete")
                                                                setSelectedAirlines(each)
                                                            }}
                                                        />
                                                        </div>
                                            </Tooltip> */}
                                    </td>
                                </tr>
                            );
                        })
                    }
                </tbody>
            </ETable>
      {/* ---------- Add New ---------- */}
       <EModal
          title="Block Airlines from Supplier"
          opened={isOpenModalValue === "New"}
          size='lg'
          onClose={() => {
                    // setNewAirlines(defaultNewAirlines);
                    resetStates();
                    setIsOpenModalValue(undefined);
                  }}
          >
                      <div className="w-full flex flex-col gap-2">
                          <ESelect
                                label="Flight Ticket Supplier"
                                placeholder="Select"
                                data={supplierList?.map((s) => ({ label: s.name, value: String(s.id) })) ?? []}
                                value={selectedSupplier?.id ? String(selectedSupplier.id) : null}
                                onChange={(e) => {
                                    setSelectedSupplier(
                                    supplierList?.find((each) => each.id == Number(e))
                                    );
                                }}
                            />
 
                          <EMultiSelect
                              label="Airlines Types"
                              placeholder="Select"
                              data={flightTypesList}
                              value={selectedFlightTypes? selectedFlightTypes : []}
                              onChange={(e) => {
                                setSelectedFlightTypes(Array.isArray(e) ? e : [e]);
                              }}
                          />
 
                          <EMultiSelect
                                label="Airlines to Block"
                                placeholder="Select"
                                data={
                                    airlinesList?.map((each) => ({
                                    label: each.name,
                                    value: String(each.id),
                                    })) ?? []
                                }
                                value={selectedAirlines?.map((each) => String(each.id)) ?? []}
                                onChange={(values) => {
                                    const selected = airlinesList?.filter((each) =>
                                    values.includes(String(each.id))
                                    );
                                    setSelectedAirlines(selected);
                                }}
                            />
 
                          <div className="flex justify-end mt-2">
                              <EButton
                                  // disabled={!(newAirlines?.name)}
                                  // loading={isBtnLoading}
                                  onClick={() => submitBlockedAirlines()}
                              >
                                  Save
                              </EButton>
                          </div>
                      </div>
       </EModal>
    </PageLayout>
  )
}
 
export default BlockAirlines;
 
 